export const CONSTANTS= {
    TIPOLOGIA_PADRE_ID_TIPO_DOCUMETNO: 160738,
    TIPOLOGIA_ID_TIPO_ENTIDAD_DOCUMENTO_GENERADO:161077,
    TIPOLOGIA_ID_TIPO_ENTIDAD_BIEN_CULTURAL:161076,
    TIPOLOGIA_ID_FICHA_DE_REGISTRO:160741,
    TIPOLOGIA_ID_PROPIEDAD_PUBLICA:160799,
    TIPOLOGIA_ID_TITULAR: 160852,
    TIPOLOGIA_ID_PROPIETARIO: 160853,
    TIPOLOGIA_ID_POSEEDOR: 160854,
    TIPOLOGIA_ID_SECCION_PREHISPANICA: 160735,
    ID_ESTADO_CERTIFICADO: 161085,
    ID_INTEGRACIONES_PLASTICAS: 161088,
    ID_FRACCIONAMIENTO:161087,
    ID_ESTADO_BORRADOR_DOCUMENTO:161084,
    TIPOLOGIA_ID_PADRE_ROLES:160730,
    TIPOLOGIA_ID_COLECCION_PREHISPANICA:161026,
    TIPOLOGIA_ID_COLECCION_BIENES_INMUEBLES:161027,
    TIPOLOGIA_ID_COLECCION_HISPANICA_REPUBLICANA:161028,
    TIPOLOGIA_ID_ESTADOS_DOCUMENTOS_GENERADOS:161083,
    ID_TIPO_TAREA_GESTION: 160796,
    ID_TIPO_TAREA_SOLICITUD:160752,
    ID_ESTADO_GESTION_COMPLETADA:160750,
    ID_DOCUMENTOS_ESTADO_CERTIFICADO: 161085,
    ID_ESTADO_GESTION_NO_COMPLETADA:160749,
    ID_ROL_ADMINISTRADOR: 160731,
    ID_ROL_TECNICO: 160732,
    ID_ORIGEN_TAREA_VENTANILLA_AGIL:160820,
    TIPOLOGIA_ID_CLASIFICACIONES:161078,
    TIPOLOGIA_ID_VACIA:160000
}